<template>
  <div>
    <naj-input
      v-if="auditConfirmations[flagName] !== undefined && mainRequest.statusId == requestStatusEnum.inComplete "
      :type-id="formFieldType.checkbox"
      :value="auditConfirmations[flagName]"
      :label="local.bankruptcy.requestDetails.auditConfirmations[flagName]"
      class="primary-label-color"
      disabled
    ></naj-input>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';
const { mapState } = createNamespacedHelpers('BankruptcyModule');

export default {
  props: {
    auditFlag: {
      type: Number,
      required: true,
    },
  },
  data() {
    return { requestStatusEnum };
  },
  computed: {
    ...mapState(['auditConfirmations', 'mainRequest']),
    flagName() { return `flag_${this.auditFlag}`; },
  },
};
</script>

<style lang="scss" scoped>
</style>
